<span
  matTooltip="{{ tooltipText }}"
  matTooltipPosition="above"
  matTooltipClass="orms-tooltip"
  [matTooltipDisabled]="!displayed"
>
  {{ text }}
</span>
